import { useEffect, useState } from 'react';
import Select from 'react-select';

import { ReactComponent as NextButton } from '../../../../assets/images/icons/next-button.svg';
import { ReactComponent as PreviousButton } from '../../../../assets/images/icons/previous-button.svg';
import defaultTheme from '../../../../styles/themes/default';
import { ButtonsContainer, Container } from './styles';

const itemsPerPageOptionsDefault = [10, 25, 50, 100];

const pageSizeSelectStyle = {
  control: (base: any) => ({
    ...base,
    minHeight: 'unset',
    height: 32,
    width: 72,
    borderColor: defaultTheme.colors.gray[400],
    boxShadow: 'none',
    cursor: 'pointer',
    '&:hover': { borderColor: defaultTheme.colors.orange.primary },
  }),
  valueContainer: (base: any) => ({ ...base, padding: '0 6px' }),
  indicatorsContainer: (base: any) => ({ ...base, height: 32 }),
  indicatorSeparator: () => ({ display: 'none' }),
  dropdownIndicator: (base: any) => ({ ...base, padding: 2 }),
  singleValue: (base: any) => ({
    ...base,
    fontSize: 12,
    color: defaultTheme.colors.gray[600],
  }),
  menu: (base: any) => ({ ...base, fontSize: 12, width: 72 }),
  menuPortal: (base: any) => ({ ...base, zIndex: 9999 }),
  option: (base: any, { isFocused, isSelected }: any) => ({
    ...base,
    fontSize: 12,
    padding: '6px 8px',
    backgroundColor: isSelected
      ? defaultTheme.colors.orange.primary
      : isFocused
        ? defaultTheme.colors.gray[100]
        : '#fff',
    color: isSelected ? '#fff' : defaultTheme.colors.gray[600],
    cursor: 'pointer',
  }),
};

interface IPaginationButton {
  itemsPerPage?: number;
  setItemsPerPage?: React.Dispatch<React.SetStateAction<number>>;
  page?: number;
  setPage?: React.Dispatch<React.SetStateAction<number>>;
  totalItems?: number;
  itemsPerPageOptions?: number[];
}

export const PaginationButtons: React.FC<IPaginationButton> = ({
  itemsPerPage,
  setItemsPerPage,
  page,
  setPage,
  totalItems,
  itemsPerPageOptions = itemsPerPageOptionsDefault,
}) => {
  const [isLastPage, setIsLastPage] = useState(false);

  useEffect(() => {
    if (totalItems && itemsPerPage && totalItems < itemsPerPage) {
      setIsLastPage(true);
    } else {
      setIsLastPage(false);
    }
  }, [totalItems]);

  const pageSizeOptions = itemsPerPageOptions?.map((item) => ({
    value: item,
    label: String(item),
  }));

  const selectedPageSize =
    pageSizeOptions?.find((option) => option.value === itemsPerPage) ?? null;

  return (
    <Container>
      <Select
        options={pageSizeOptions}
        value={selectedPageSize}
        onChange={(option) => option && setItemsPerPage?.(option.value)}
        isDisabled={!setItemsPerPage}
        isSearchable={false}
        styles={pageSizeSelectStyle}
        menuPortalTarget={
          typeof document !== 'undefined' ? document.body : undefined
        }
      />
      Página {page}
      <ButtonsContainer>
        <button
          type="button"
          onClick={
            setPage && page && page > 1
              ? () => setPage(page ? page - 1 : 1)
              : undefined
          }
          disabled={page === 1}
        >
          <PreviousButton />
        </button>
        <button
          type="button"
          onClick={
            setPage && !isLastPage
              ? () => setPage(page ? page + 1 : 1)
              : undefined
          }
          disabled={isLastPage}
        >
          <NextButton />
        </button>
      </ButtonsContainer>
    </Container>
  );
};
